import type { Types } from '../types';
import type { OutTypes } from './schedules';
import { getVertexId } from '../util';
import { omitEdgesAndInternalProperties, type SerializedEdgesOnlyVertexExport, type SerializedEdgesShape } from './util';
import type { BaseOptions } from '../../common/types';
import type { LocationVertex } from '../interfaces/vertices/locations';

export default (
  locations: Types.Mixed.Location[],
  options:   BaseOptions
): OutTypes.location[] => {
  return locations
    .map(x => {
      const edges: SerializedEdgesOnlyVertexExport<LocationVertex> = {
        exceptions:  x.exceptions ?.map(x => getVertexId(x, options)),
        lockedTimes: x.lockedTimes?.map(x => getVertexId(x, options)),
        lunch:       x.lunch      ?.map(x => getVertexId(x, options)),
      } satisfies SerializedEdgesShape<SerializedEdgesOnlyVertexExport<LocationVertex>>;
      const nonEdges = omitEdgesAndInternalProperties(x, edges);

      return { ...nonEdges, ...edges };
    });
};
